<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start">
        <button-add value="添加退款记录" pathName="add-finance-refund" v-if="permissionCodes.indexOf('013018001') !== -1"/>
        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" v-if="permissionCodes.indexOf('013018003') !== -1" style="margin-left: 10px;" value="导出"/>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="住户名称" @search="searchKey" />
      </div>
    </div>
    <div class="search-line" style="justify-content: flex-start">
      <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                      :picker-options="pickerOptions2" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
        <input-select selectTitle="退款状态" selectKey="status" :selectData="statusList" @search="search" style="margin-left: 10px" />
      <div style="display: flex;">
<!--        <input-select selectTitle="开票状态" :selectKey="'invoiceStatus'" :selectData="invoiceStatusList" @search="search" style="margin-right: 10px;"/>-->
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @confirmRefundFinanceRow="confirmRefundFinanceRow" @changePagination="changePagination" :operationArr="['confirmRefundFinance']" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from "../../../utils/notice";
  import ButtonCancel from "../../../components/Button/ButtonCancel";

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'finance-refund',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '退款管理'
        }],
        exportUrl: '',
        timevalue: [],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        statusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '0',
            label: '未退款'
          }, {
            key: '1',
            label: '已退款'
          }
        ],
        payChannelList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],
        tableHead: [{
          prop: 'refundObj',
          label: '退款对象'
        }, {
          prop: 'paymentItemName',
          label: '退款账单'
        }, {
          prop: 'billAmount',
          label: '账单金额(元)'
        }, {
          prop: 'refundAmount',
          label: '退款金额(元)'
        }, {
          prop: 'actualRefundAmount',
          label: '实退金额(元)'
        }, {
          prop: 'operator',
          label: '经办人'
        }, {
          prop: 'statusText',
          label: '退款状态'
        }, {
          prop: 'refundTime',
          label: '退款时间'
        }, {
          prop: 'memo',
          label: '备注'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          status: '',
          startTime: '',
          endTime: ''
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportRefund}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&status=${this.requestData.status}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getRefundPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.financeTotalBill) {
                  v.paymentItemName = v.financeTotalBill.paymentItemName
                }
                if (v.status === '0') {
                  v.statusText = '未退款'
                } else if (v.status === '1') {
                  v.statusText = '已退款'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      confirmRefundFinanceRow (data) {
        this.$confirm('是否确认退款', "温馨提示", {
          type: "warning"
        })
          .then(() => {
            this.$axios.post(api.confirmRefund, data)
              .then(res => {
                nSuccess('操作成功')
                this.getPage()
              })
              .catch(errorHandler('操作失败'))
          })
          .catch(() => {
            console.log("取消退款");
          });
      }
    },
    watch: {
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/FinanceRefund/financeRefund.vue